var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 5.49984V1.49984C5.33333 1.14622 5.47381 0.807077 5.72386 0.557028C5.97391 0.30698 6.31305 0.166504 6.66667 0.166504H22.6667C23.0203 0.166504 23.3594 0.30698 23.6095 0.557028C23.8595 0.807077 24 1.14622 24 1.49984V20.1665C24 20.5201 23.8595 20.8593 23.6095 21.1093C23.3594 21.3594 23.0203 21.4998 22.6667 21.4998H18.6667V25.4998C18.6667 26.2358 18.0667 26.8332 17.324 26.8332H1.34267C1.16684 26.8342 0.99253 26.8005 0.829763 26.734C0.666997 26.6675 0.518978 26.5695 0.394211 26.4456C0.269445 26.3217 0.170391 26.1743 0.102739 26.012C0.0350875 25.8497 0.000172499 25.6757 0 25.4998L0.00400003 6.83317C0.00400003 6.09717 0.604 5.49984 1.34667 5.49984H5.33333ZM2.67067 8.1665L2.66667 24.1665H16V8.1665H2.67067ZM8 5.49984H18.6667V18.8332H21.3333V2.83317H8V5.49984Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.2d1345b0b41ef1e5568cef2bac41949a.svg";
export { ForwardRef as ReactComponent };